import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimburtTravelItemsApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimburtTravelItems'
  }

}